namespace $ { $mol_style_attach( "mol/follower/follower.view.css",
 "[mol_follower] {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\ttransition: none;\n}\n"
) }